
import lineDatabase from "~/services/database/line";
import smsDatabase from "~/services/database/sms";
import _ from "lodash"

export const useNotificationStore = defineStore("notification", {
  state: () => ({
    notifyList:[],
    notifyLine: {}
  }),
  actions: {
    async sendToLine(payload:any): Promise<void>{     
        await lineDatabase()._create(payload) 
    },
    async sendToSms( payload:any): Promise<void>{    
        await smsDatabase()._create(payload)  
    },   
    async fetchUserInfoNotify(){
      // const userStore = useUserStore();
      // const eventStore = useEventStore();
      // const notifyObjList = eventStore.event?.notify?.line
      // let list = []
      // if(notifyObjList){
      //   for(let key in notifyObjList){           
      //     if(notifyObjList[key]){
      //       let user = await userStore.getUserById(key)
      //       list.push({...user, notifyStatus: notifyObjList[key]})          
      //     }
            
      //   }
      // }     
      // this.notifyList = list //  _.values(notifyObjList)  //
      // // this.notifyLine = notifyObjList

    }, 

    async sendNotifySMSToUser(messages: any) {
      const from  = "photowishApp"
      const photoWishTeamContact = ['0985461451','0846457970','0818460621']  //Chompoo, pae, p'rice
      // const photoWishTeamContact = ['0985461451']  //Chompoo, pae, p'rice
    
      for (let index = 0; index < messages.length; index++) {
        let message = messages[index];
        message = message?.replaceAll('\n', '%0A')
        await this.sendToSms({
          createdAt: new Date().toISOString(),
          message,
          from,
          to: photoWishTeamContact,
        })
      }
    }
  },
});
